<app-item-side-bar
	*ngFor="let menuitem of sideBarMenus"
	[menuitem]="menuitem"
	(itemClicked)="onClickItem($event)"
></app-item-side-bar>
